export const IS_AUTHENTICATED = 'IS_AUTHENTICATED'
export const AUTHENTICATE = 'AUTHENTICATE'
export const INVALIDATE = 'INVALIDATE'
export const SET_USER_INFO = 'SET_USER_INFO'
export const CHANGE_ENVIRONMENT = 'CHANGE_ENVIRONMENT'
export const SET_OR_UPDATE_NONCES = 'SET_OR_UPDATE_NONCES'
export const MAINTENANCE_SETTINGS = 'MAINTENANCE_SETTINGS'

export default {
    IS_AUTHENTICATED,
    AUTHENTICATE,
    INVALIDATE,
    SET_USER_INFO,
    CHANGE_ENVIRONMENT,
    SET_OR_UPDATE_NONCES,
    MAINTENANCE_SETTINGS
}
